export default __webpack_public_path__ + "static/media/arrDashboard.ae71e011.svg";